import React from 'react';

const SizeChartModal = ({ onClose }) => {
  // Data structured for easier mapping with sizes as columns
  const measurements = {
    chest: { XS: '19.875', S: '22', M: '24', L: '26' },
    length: { XS: '21.5', S: '25.35', M: '26.75', L: '29' },
  };
  const sizesOrder = ['XS', 'S', 'M', 'L'];

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white p-4 sm:p-6 rounded-lg shadow-2xl max-w-lg w-full relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          onClick={onClose} 
          className="absolute top-2 right-2 sm:top-3 sm:right-3 text-gray-400 hover:text-gray-700 bg-gray-100/50 hover:bg-gray-200/70 rounded-full p-1.5 transition-colors"
          aria-label="Close size chart"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5 sm:w-6 sm:h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 text-center">Tee Size Chart (in)</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left text-gray-700 table-fixed">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100/70">
              <tr>
                <th scope="col" className="py-2 px-3 sm:py-3 sm:px-4 rounded-tl-lg w-1/4">Measurement</th>
                {sizesOrder.map(size => (
                  <th key={size} scope="col" className="py-2 px-3 sm:py-3 sm:px-4 text-center w-1/5">{size}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200 hover:bg-gray-50/70 transition-colors">
                <th scope="row" className="py-2 px-3 sm:py-3 sm:px-4 font-medium text-gray-900 whitespace-nowrap">Chest</th>
                {sizesOrder.map(size => (
                  <td key={size} className="py-2 px-3 sm:py-3 sm:px-4 text-center">{measurements.chest[size]}</td>
                ))}
              </tr>
              <tr className="hover:bg-gray-50/70 transition-colors">
                <th scope="row" className="py-2 px-3 sm:py-3 sm:px-4 font-medium text-gray-900 whitespace-nowrap">Length</th>
                {sizesOrder.map(size => (
                  <td key={size} className="py-2 px-3 sm:py-3 sm:px-4 text-center">{measurements.length[size]}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-xs text-gray-500 mt-4 text-center">Measurements are approximate and in inches.</p>
      </div>
    </div>
  );
};

export default SizeChartModal; 